var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrontend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "20px",
    height: "20px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "connection"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "page"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92,4H32c-2.2,0-4,1.8-4,4v4h-4c-2.2,0-4,1.8-4,4v4h-4c-2.2,0-4,1.8-4,4v4H8c-2.2,0-4,1.8-4,4v60c0,2.2,1.8,4,4,4h60    c2.2,0,4-1.8,4-4v-4h4c2.2,0,4-1.8,4-4v-4h4c2.2,0,4-1.8,4-4v-4h4c2.2,0,4-1.8,4-4V8C96,5.8,94.2,4,92,4z M30,8c0-1.1,0.9-2,2-2    h60c1.1,0,2,0.9,2,2v6h-6.6c-0.7-1.2-2-2-3.4-2h-1h-6H30V8z M22,16c0-1.1,0.9-2,2-2h60c1.1,0,2,0.9,2,2v6h-6.6c-0.7-1.2-2-2-3.4-2    h-1h-6H22V16z M14,24c0-1.1,0.9-2,2-2h60c1.1,0,2,0.9,2,2v6h-6.6c-0.7-1.2-2-2-3.4-2h-1h-6H14V24z M8,30h60c1.1,0,2,0.9,2,2v6H6    v-6C6,30.9,6.9,30,8,30z M70,92c0,1.1-0.9,2-2,2H8c-1.1,0-2-0.9-2-2V40h64V92z M78,84c0,1.1-0.9,2-2,2h-4V32h6V84z M86,76    c0,1.1-0.9,2-2,2h-4V24h6V76z M92,70h-4V16h6v52C94,69.1,93.1,70,92,70z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 34,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 34,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 34,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,55h52c1.7,0,3-1.3,3-3v-6c0-1.7-1.3-3-3-3H12c-1.7,0-3,1.3-3,3v6C9,53.7,10.3,55,12,55z M11,46c0-0.6,0.4-1,1-1h52    c0.6,0,1,0.4,1,1v6c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1V46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,69H12c-1.7,0-3,1.3-3,3v16c0,1.7,1.3,3,3,3h24c1.7,0,3-1.3,3-3V72C39,70.3,37.7,69,36,69z M37,88c0,0.6-0.4,1-1,1H12    c-0.6,0-1-0.4-1-1V72c0-0.6,0.4-1,1-1h24c0.6,0,1,0.4,1,1V88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,64H11c-0.6,0-1,0.4-1,1s0.4,1,1,1h56c0.6,0,1-0.4,1-1S67.6,64,67,64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,59H11c-0.6,0-1,0.4-1,1s0.4,1,1,1h56c0.6,0,1-0.4,1-1S67.6,59,67,59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,69H43c-0.6,0-1,0.4-1,1s0.4,1,1,1h23c0.6,0,1-0.4,1-1S66.6,69,66,69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,74H43c-0.6,0-1,0.4-1,1s0.4,1,1,1h23c0.6,0,1-0.4,1-1S66.6,74,66,74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,79H43c-0.6,0-1,0.4-1,1s0.4,1,1,1h23c0.6,0,1-0.4,1-1S66.6,79,66,79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,84H43c-0.6,0-1,0.4-1,1s0.4,1,1,1h23c0.6,0,1-0.4,1-1S66.6,84,66,84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,89H43c-0.6,0-1,0.4-1,1s0.4,1,1,1h23c0.6,0,1-0.4,1-1S66.6,89,66,89z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "support"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "configuration"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "cloud_storage"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "password"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "search_engine"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "history"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SEO"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "optimization"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "backlink"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "performance"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "analytics"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "security"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "dark_web"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "video_player"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "upload_download"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "incognito_tab"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "bookmark"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontend);
export default __webpack_public_path__ + "static/media/frontend.23ccb275687ef619610e1083aa8c99d8.svg";
export { ForwardRef as ReactComponent };